import React, { useContext, useState } from 'react';
import { LanguageContext } from './LanguageContext';
import classes from './LanguageSelector.module.css';

/* const languages = [
  { code: 'eng', label: 'EN', icon: '🇬🇧' },
  { code: 'ar', label: 'AR', icon: '🇸🇦' },
  { code: 'fr', label: 'FR', icon: '🇫🇷' },
  { code: 'es', label: 'ES', icon: '🇪🇸' },
  { code: 'sw', label: 'SW', icon: '🇹🇿' },
];*/

const languages = [
  { code: 'sw', label: 'SW', icon: '🇹🇿' },
  { code: 'eng', label: 'EN', icon: '🇬🇧' },
];
const LanguageSelector = () => {
  const { lang, setLang } = useContext(LanguageContext);
  const [open, setOpen] = useState(false);

  const currentLang = languages.find((l) => l.code === lang) || languages[0];

  const selectLang = (code) => {
    setLang(code);
    document.body.dir = code === 'ar' ? 'rtl' : 'ltr';
    setOpen(false);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.toggle} onClick={() => setOpen(!open)}>
        <span className={classes.icon}>{currentLang.icon}</span>
        <span className={classes.text}>{currentLang.label}</span>
      </div>

      {open && (
        <div className={classes.dropdown}>
          {languages.map((l) => (
            <div
              key={l.code}
              className={`${classes.option} ${lang === l.code ? classes.active : ''}`}
              onClick={() => selectLang(l.code)}
            >
              <span>{l.icon}</span>
              <span>{l.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
